import {BookingStatusNames} from "app/bookingStatusTypes";
import MenuOptionsService from "app/services/menuOptions/menuOptions.service";
import {
  PaymentTypes,
  PricingTypes,
  BookingStateChangeTypes,
  BookingMethods,
  servicePaymentType
} from "shared-types/index";
import {first} from "rxjs/operators";
import {ManualJoinType} from "shared-components/table-seater/types";
import { StatusService, StatusServiceInstance } from "external-services/status-service/index";
import {UrlGeneratorService} from "external-services/url-generator-service/UrlGenerator.service";
import {cloneDeep, isEmpty} from "lodash-es";
import { CustomerGeneratorService } from "external-services/customer-generator-service";
import ReportingService from 'app/services/reporting/reporting.service';
import ObjectCopyService from "external-services/object-copy-service/index";
import BeverageHistoryService from "app/services/beverageHistory/BeverageHistory.service";
import MenuOptionReducerService from "app/fakeReducer/menuOption.reducer";
import NetworkConnectionService from 'external-services/network-connection-service/index';
import PaymentService from "external-services/diary-payment-service";
import TelemetryService from "app/services/telemetry/telemetry.service";
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import TrackingService from 'app/services/tracking/tracking.service';
import BookingOptionsManagerService from "app/services/bookingOptionsManager/bookingOptionsManager.service";
import TagsService from "external-services/tags-service";
import AdminService from "external-services/diary-admin-service/admin.service";
import ManagerService from "external-services/manager-service/manager.service";
import moment from "moment";
import BookingNotificationsService from 'external-services/booking-notification-service/bookingNotifications.service';
import CustomerService from "internal-services/customer/customer.service";
import {AdminServiceLog, CustomerTypes} from "app/app.types";
import DateUtilsService from 'external-services/date-utils-service';
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import PhoneNumberService from "external-services/phone-number-service/index";
import StaffService from "external-services/staff-service/staff.service";
import BookingLookupService from "external-services/booking-lookup-service/index";
import BookingUpdateService from "external-services/booking-update-service/index";
import SimpleDialogActions from 'app/actions/simpleDialog.actions';
import BookingsUtilsService from 'app/services/bookingsUtils/bookingsUtils.service';
import RecurringBookingService from 'shared-services/recurring-booking-service';
import CompareObjectsService from 'external-services/compare-objects-service/CompareObjects';
import CustomerLookupService from 'external-services/customer-lookup-service';
import PaymentValidationService from 'app/services/paymentValidation/paymentValidation.service';
import BookingValidationService from "shared-services/booking-validation-service/index";
// Just for getFlatExtras function
import MenuOptionsServiceShared from "external-services/menu-options-service/index";
import CustomerSearchService, { RestrictResult } from "external-services/customer-search-service";
import BookingListFilterService from "external-services/booking-list-filter-service/index";
import store from "appRoot/Store";
import StatusConfigService from "external-services/status-config-service";
import CustomerUpdateService from "external-services/customer-update-service/customerUpdate.service";
import LinearSaveService from "app/services/linearSave/LinearSaveService";

const NS = 'NewBooking';

/**
 * element contains $element object, which is passed from the main.controller.js
 */
export default function NewBooking(
  $rootScope, $window, $scope, $log, $mdDialog, $filter, $interpolate,
  bookDate, bookTable, bookingMethod, customer, bookingToMove, bookingDuration, selectedService,
  unregister, isTouchDevice,
  appConstants, appValues,
  BookingType, BookingStatusTypes, hardCodedTags, AppEventService, element,
  AuthService,
) {
  "ngInject";

  var vm = this;
  var setting;
  var pagePath = 'booking.new.' + bookingMethod;
  const GUESTLIST_TAB = 'guestList';
  const PAYMENT_TAB = 'payment';
  const BOOKING_OPTIONS_TAB = 'booking options';
  const REPEAT_BOOKING_TAB = 'recurring bookings';
  const UPSELL_OPTIONS_TAB = 'upsell options';

  let paymentTypeSubs; // type Subscription (rxjs)
  let customerCopy;
  // states (@todo: implement BookingNewCtrlStates)
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.SUCCESS = 2;
  vm.ERROR = 3;
  vm.ERROR_LOADING = 4;
  vm.state = vm.ENTER;
  vm.NoPayment = servicePaymentType.noPayment;
  vm.bookingDuration = bookingDuration;
  vm.selectedServiceFromHeader = selectedService;
  vm.BookingType = BookingType;
  vm.isUpsell = true;
  vm.requestParameters = {};

  /**
   * Because this controller gets added via $mdDialog, there is no default lifecycle hooks,
   * so this needs to get called from within the `onComplete` callback.
   */
  $scope.$onInit = function () {

    //-- define public properties
    vm.isNewBooking = true;
    vm.heading = (bookingMethod === BookingMethods.phone) ? 'New Booking' : 'New Walk in';
    vm.bookingMethod = bookingMethod;
    vm.phone = BookingMethods.phone;
    vm.walkin = BookingMethods.walkin;
    vm.isManager = ManagerService.isManager;
    vm.selectedTab = 0;
    vm.initialTag = false;
    vm.canSave = false;
    vm.isDisabled = false;
    vm.selectedTime = null;
    vm.setPhone = setPhone;
    vm.setEmail = setEmail;
    vm.staffRequired = false;
    vm.showTabs = {};
    vm.STANDBY_LIST = BookingType.StandbyList;
    vm.finalConfirmation = false;
    vm.isLoadingBookingOptionsPaymentInfo = false;
    vm.isBookingToMove = false;
    vm.venue = AdminService.getVenue();
    vm.disableEmailSmsNotification = vm.venue.defaultDisableBookingCommunication
    vm.appVersion = appValues.VERSION_SHORT;
    vm.paymentAvailableTabOffset = 0;
    vm.bookingLinks = [{
      linkName: '',
      linkURL: ''
    }];
    vm.beverageList = [];
    vm.openRepeatBookingTab = false;
    vm.shouldShowRepeatBookingIcon = false;
    vm.closeRepeatBookingTab = closeRepeatBookingTab;
    vm.handleOriginalCustomerChange = handleOriginalCustomerChange;
    vm.bookedByCustomerDetails = {
      subscribed: vm.venue.defaultEmailSubscribedForDiary,
      disableEmailSmsNotification: false //Do not send emails or SMS to Booked By (not enabled by default)
    };
    vm.setBookedByCustomerDetails = setBookedByCustomerDetails;
    vm.cleanBookedByData = cleanBookedByData;
    if (customer) {
      vm.customerValid = true;
      vm.customer = customer;
    } else {
      if (bookingToMove) {
        if (updateOfflineStatus() || !bookingToMove.customerId) {
          vm.customer = CustomerGeneratorService.getCustomerInfo(bookingToMove);
        } else {
          if (bookingToMove.customerId) {
            // this condition should NOT happen, unless there is some issue when checking the existing customer
            // sends message to get logged on SEQ
            const notes = `Booking Customer Data: {"CustomerId": "${bookingToMove.customerId}",
                           "Firstname": "${bookingToMove.firstName}", "Lastname": "${bookingToMove.lastName}",
                           "BookingId": "${bookingToMove._id}",
                           "phone": "${bookingToMove.phone}",
                           "email": "${bookingToMove.email}"}`;
            const message = "Moving Booking request with a customer null reference - app version: " + vm.appVersion;
            AdminService.serverLoggingDbEvents(vm.venue.id, message, AdminServiceLog.WARNLOG, notes);

            // Tries to retrieve the customer again - but this
            CustomerLookupService.getById(bookingToMove.customerId)
              .then(customer => {
                if (customer != null) {
                  vm.customer = customer;
                } else {
                  vm.customer = CustomerGeneratorService.getCustomerInfo(bookingToMove);
                  vm.customer.id = bookingToMove.customerId;
                }
                console.log("Moving Booking", customer);
                return;
              }).catch(() => {
                vm.customer = CustomerGeneratorService.getCustomerInfo(bookingToMove);
                console.log("Moving Booking", "Error when verifying customer - Using previous customer data", vm.customer);
              });
          }
        }
      } else {
        vm.customer = CustomerGeneratorService.getEmptyCustomer(bookingMethod, null, vm.venue.defaultEmailSubscribedForDiary);
      }
    }

    vm.guestListValid = true;
    vm.bookingOptionsValid = true;
    vm.upsellOptionsValid = false;
    if (!isTouchDevice) {
      vm.showComplete = true;
    }
    vm.theme = AdminService.getThemeValues();
    vm.isStandbyListEnabled = vm.venue.standByList || false;

    vm.tabs = ['booking', 'customer', 'tags', 'notes', 'links'];
    vm.isBookingOption = false;
    vm.isUpsellOptions = false;
    vm.showBookingOption = true;
    vm.showUpsellOptions = true;
    vm.menuOptions = [];
    vm.menuOptionsUpsell = [];
    vm.selectedMenuOptions = [];
    vm.allBookingOptions = [];
    vm.bookingOptionPaymentDetails = {};
    vm.upsellPageSkip = false;
    vm.isRecurringBookingSaved = false;
    vm.paymentDetailsChanged = false;
    vm.originalPaymentDetails = {};
    vm.isChangeByUser = false;
    vm.isCancelPreviousSB = false;
    vm.customerSBL = [];
    vm.customers = [];
    vm.skipCustomerDuplicationCheck = false;

    //-- define public methods
    vm.cancelDialog = cancelDialog;
    vm.save = save;
    vm.checkForSave = checkForSave;
    vm.updateTabs = updateTabs;
    vm.nextTab = nextTab;
    vm.backTab = backTab;
    vm.updateLables = updateLables;
    vm.tryAgain = tryAgain;
    vm.toggleLocked = toggleLocked;
    vm.getPaymentTypeName = getPaymentTypeName;
    vm.handleBookingUpdated = handleBookingUpdated;
    vm.updateBookingOption = updateBookingOption;
    vm.resetTableData = resetTableData;
    vm.handleMaxCovers = handleMaxCovers;
    vm.toggleBookingOptions = toggleBookingOptions;
    vm.toggleUpsellOptions = toggleUpsellOptions;
    vm.updateBookingLink = updateBookingLink;
    vm.addBookingLink = addBookingLink;
    vm.updateRecurringBookings = updateRecurringBookings;
    vm.resetRecurringBookings = resetRecurringBookings;
    vm.handleSendLinkPaymentResponseAndCloseOnSuccess = handleSendLinkPaymentResponseAndCloseOnSuccess;
    vm.checkForCovidGuestTab = checkForCovidGuestTab;
    vm.paymentChange = paymentChange;
    vm.handleEmailSmsNotification = handleEmailSmsNotification;
    vm.handleNewCustomerSelected = handleNewCustomerSelected;
    vm.setSkipCustomerDuplicationCheck = setSkipCustomerDuplicationCheck;
    vm.setHiddenDialog = setHiddenDialog;

    vm.dialogContainer = null;

    vm.validationChecked = (includeScroll) => {
      validationChecked();
      if (includeScroll) {
        const restrictedItems = Array.isArray(includeScroll) ? includeScroll : null;
        BookingValidationService.scrollToValidationError(vm.selectedTab, vm.validationList, restrictedItems);
      }
    };
    vm.setEmptyCustomer = setEmptyCustomer;

    vm.bookingReactRerender = bookingReactRerender;
    vm.serviceId = '';
    vm.customerBookings = [];
    vm.avgSpendAmount = null;

    vm.isUsingWidgetV2 = vm.theme.widgetVersion === 2;
    vm.widgetUrl = vm.isUsingWidgetV2 ? $window.config.widgetV2Url : $window.config.widgetUrl;
    PaymentValidationService.init();
    TrackingService.trackPageView(pagePath);

    //-- init
    LinearSaveService.init(vm);
    NetworkConnectionService.checkCouchDbIsReachable();
    GeneralSettingsService.get().then(function (s) {
      setting = s;

      // check couch url/name still correct
      AdminService.restartPeriodicCouchNameCheck(); // restarts the timer
      AdminService.loadVenue(vm.venue.id, true, true).catch(function (err) {
        console.error(NS, 'AdminService.loadVenue', err);
        AuthService.checkAuth().then((res) => {
          if (!res) {
            $mdDialog.cancel();
          }
        });
      });

      initBooking(bookingToMove, bookDate, bookTable);
      addListeners(); // should come after vm.booking is set
      vm.oldBooking = ObjectCopyService.angularSafeCopy(vm.booking);
      vm.initialCustomerDtls = cloneDeep(vm.customer);
      vm.initialBookingLinks = cloneDeep(vm.bookingLinks);

      vm.removeMinH = true;
    });

    getSectionsLookUp();
    getAllTags();
  };
  function getAllTags() {
    TagsService.getTags().then(function (tags) {
      // we never need to show the delivery tag for new bookings. It is only ever needed on booking options when in Takeaway mode
      vm.allTags = tags.filter(t => t._id !== hardCodedTags.DELIVERY_TAG_ID);
    });
  }


  function addListeners() {
    //-- listen
    const listeners = [];
    listeners.push($scope.$watch('bookingNew.bookingDate', checkStatus));
    listeners.push($scope.$watch('bookingNew.statusName', statusUpdate));
    listeners.push($scope.$watch('bookingNew.selectedTime', updateTabs));
    listeners.push($scope.$watch('bookingNew.customerValid', updateTabs));
    listeners.push($scope.$watch('bookingNew.guestListValid', updateTabs));
    listeners.push($scope.$watch('bookingNew.openRepeatBookingTab', updateTabs));
    listeners.push($scope.$watch('bookingNew.selectedTab', tagChange));
    listeners.push($scope.$watch('bookingNew.booking.time', (newValue, oldValue) => {
      if (newValue !== oldValue) {
        updateLables();
        MenuOptionReducerService.setBookingTime(newValue);
      }
    }));
    listeners.push($scope.$watch('bookingNew.booking.tags.length', updateLables));
    listeners.push($scope.$watch('bookingNew.booking.staffName', validationChecked));
    listeners.push($scope.$watch('bookingNew.booking.people', prefillPayment));
    listeners.push($scope.$watch('bookingNew.booking.paymentDetails.paymentType', validationChecked));
    listeners.push($scope.$watch('bookingNew.booking.paymentDetails.price', validationChecked));
    listeners.push($scope.$watch('bookingNew.booking.bookingType', validationChecked));
    listeners.push($scope.$watch('bookingNew.service', prefillPayment));
    listeners.push($scope.$watch('bookingNew.staffName', validationChecked));
    listeners.push($scope.$on('tags-updated', updateLables));
    listeners.push($scope.$watch('bookingNew.booking.notes', updateLables));
    listeners.push($scope.$watch('bookingNew.customer.notes', updateLables));
    listeners.push($scope.$watch('bookingNew.customer._id', onCustomerIdChange));
    listeners.push($scope.$watch('bookingNew.customer.managerNotes', updateLables));
    listeners.push($scope.$watch('bookingNew.customer.tags', checkPermanentTags));
    listeners.push($scope.$watch('bookingNew.bookingOptionsValid', validationChecked));
    listeners.push($scope.$watch('bookingNew.isChangeByUser', paymentChange));
    listeners.push($scope.$watch('bookingNew.disableEmailSmsNotification', handleEmailSmsNotification));

    vm.dialogContainer = element[0].querySelector(".md-dialog-container");
    vm.dialogContainer.addEventListener('click', canShowConfirmationDialog);
    vm.dialogContainer.addEventListener('touchstart', canShowConfirmationDialog);

    listeners.push($scope.$on('$destroy', () => {
      removeConfirmationDialogListener();
      unregister(listeners);
    }));
  }

  /**
   * Removes the click and touchstart event listener
   */
  function removeConfirmationDialogListener() {
    vm.dialogContainer.removeEventListener('click', canShowConfirmationDialog);
    vm.dialogContainer.removeEventListener('touchstart', canShowConfirmationDialog);
  }

  /**
   * Determine whether to show the confirmation dialog, when clicked outside the form.
   */
  function canShowConfirmationDialog(e) {
    // Do not compare, when not clicked outside the dialog
    if (e.target.className !== "md-dialog-container") return;
    // Display the dialog when the form is loaded and has unsaved data
    if (vm.oldBooking.serviceId && vm.state === vm.ENTER && doesBookingFormHaveUnsavedData(e)) {
      showSaveConfirmationDialog();
    } else if (vm.state === vm.SHOW_PAYMENT_URL && (
      PaymentValidationService.paymentPhone?.replaceAll(' ','') !== vm.customer?.phone?.replaceAll(' ','')
        || PaymentValidationService.paymentEmail !== vm.customer?.email
      )
    ) {
      showPaymentConfirmationDialog();
    } else {
      /**
       * When you click on the "CLOSE" button in the confirmation dialog, the NewBooking form dialog is closed.
       * But, if you quickly click on the NewBooking form dialog while it's closing, the confirmation dialog is opened again due to the click event listener.
       * So, calling the remove listener to avoid opening the confirmation dialog again.
       */
      removeConfirmationDialogListener();

      // Close the NewBooking form
      cancelDialog();
    }
  }

  /**
   * Detect unsaved data by comparing the initial and new data.
   */
  function doesBookingFormHaveUnsavedData() {

    // Check booking data
    const booking = cloneDeep(vm.booking);
    if (!CompareObjectsService.hasIdenticalData(booking, vm.oldBooking)) return true;

    // Check customer data
    const customer = cloneDeep(vm.customer);
    if (!CompareObjectsService.hasIdenticalData(customer, vm.initialCustomerDtls)) return true;

    // Check booking links
    if (vm.bookingLinks.length !== vm.initialBookingLinks.length) return true;
    const bookingLinks = cloneDeep(vm.bookingLinks);
    if (!CompareObjectsService.hasIdenticalData(bookingLinks, vm.initialBookingLinks)) return true;

    // Check booking option toggle
    if (!vm.showBookingOption) return true;

    // Check booking option menu
    const hasMenuOptionSelected = vm.selectedMenuOptions.some(option => option.quantity > 0);
    if (hasMenuOptionSelected) return true;

    // Check table dropdown
    if (vm.tableId && vm.tableId !== "auto" && vm.initialTableId !== vm.tableId) return true;

    return false;
  }

  /**
   * Display save booking confirmation dialog
   */
  function showSaveConfirmationDialog() {
    const dialogMessage = "This booking is incomplete or has not been saved.\nBy pressing close, you will lose changes you have made. By pressing continue, you can continue making changes.";
    const headerMsg = 'Save confirmation';
    SimpleDialogActions.showDialog({
      description: dialogMessage,
      title: headerMsg,
      confirmText: 'Continue',
      rejectText: 'Close',
      handleConfirm: () => {
        SimpleDialogActions.hideDialog();
      },
      handleReject: cancelDialog
    });
  }

  function showPaymentConfirmationDialog() {
    const dialogMessage = "Unsaved changes.\nBy pressing close, you will lose any changes you have made. By pressing continue, you can continue making changes.";
    const headerMsg = 'Payment link confirmation';

    SimpleDialogActions.showDialog({
      description: dialogMessage,
      title: headerMsg,
      confirmText: 'Continue',
      rejectText: 'Close',
      handleConfirm: () => {
        SimpleDialogActions.hideDialog();
      },
      handleReject: cancelDialog
    });
  }

  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  function showCancelPreviousSBLConfirmationDialog() {
    const dateStr = DateUtilsService.getViewDateFromMoment(moment(vm.booking.time));
    const customerName = capitalizeFirstLetter(vm.customer.firstName) + (vm.customer.lastName ? ' ' + capitalizeFirstLetter(vm.customer.lastName) : '')
    const dialogMessage = "`" + customerName + "` is already on the Standby List for " + dateStr + ". Do you want to cancel the existing request on the Standby List and create this as a new one?";
    const headerMsg = 'Save confirmation';
    SimpleDialogActions.showDialog({
      description: dialogMessage,
      title: headerMsg,
      confirmText: 'Yes',
      rejectText: 'No',
      handleConfirm: async () => {
        vm.isCancelPreviousSB = true;
        await setCustomerSBLToCancelled()
        SimpleDialogActions.hideDialog();
        save();
      },
      handleReject: () => {
        cancelDialog();
      }
    });
  }

  function showTryConfirmationDialog() {
    const dialogMessage = "There was an error saving your Standby List request please try again.";
    const headerMsg = 'Try saving again.';
    SimpleDialogActions.showDialog({
      description: dialogMessage,
      title: headerMsg,
      confirmText: 'Yes',
      rejectText: 'No',
      handleConfirm: () => {
        SimpleDialogActions.hideDialog();
        save();
      },
      handleReject: () => {
        SimpleDialogActions.hideDialog();
      }
    });
  }

  async function prefillPayment() {
    vm.isBookingOption = false;
    vm.isUpsellOptions = false;
    vm.booking.selectedMenuOptions = []; // To fix the issue where the BO was remaining selected even if you change the PAX to deactivate BO
    MenuOptionReducerService.setBooking({...vm.booking, selectedMenuOptions: []}); // Resets All BO and Upsell Options on change of PAX
    vm.tabs = vm.tabs.filter(tab => tab !== BOOKING_OPTIONS_TAB);
    vm.tabs = vm.tabs.filter(tab => tab !== UPSELL_OPTIONS_TAB);
    vm.bookingOptionsValid = true;
    vm.showBookingOption = true;
    updateTabs();

    vm.activePaymentDetails = null;
    vm.paymentAvailableTabOffset = !vm.showTabs.payment ? 1 : 0; // If payment tab is not available then we need to deduct the positioning of the BO and Upsell Options
    if (vm.service) {
      PaymentService.populateDefaultPricingTypes(vm.service.paymentDetails, vm.service.additionalPaymentDetails);
      vm.activePaymentDetails = PaymentService.getPaymentDetailsByService(vm.booking.people, vm.service.paymentDetails, vm.service.additionalPaymentDetails, vm.bookingDate);
    }

    if (vm.service && vm.activePaymentDetails && vm.bookingMethod !== vm.walkin && !bookingToMove) {

      const isPaxThresholdValid = vm.activePaymentDetails.peopleRequired <= vm.booking.people;

      // to remove the price and change payment type to no payment if BO exists on the payment
      const isPriceAndBoAvailable = PaymentService.isPriceAndBoAvailable(vm.activePaymentDetails);

      if (vm.activePaymentDetails.price && isPaxThresholdValid && !isPriceAndBoAvailable) {
        vm.booking.paymentDetails = {
          paymentType: vm.activePaymentDetails.paymentType,
          price: vm.activePaymentDetails.pricingType === PricingTypes.PerBooking ? vm.activePaymentDetails.price : Number.parseFloat((vm.activePaymentDetails.price * vm.booking.people).toFixed(2)),
          pricingType: vm.activePaymentDetails.pricingType
        };
      } else {
        vm.booking.paymentDetails = {
          paymentType: PaymentTypes.NoPayment,
        };
      }
      // setting the original payment before the user starts making the changes - Any changes after that will show the payment updated msg
      if (!vm.isChangeByUser) {
        vm.isChangeByUser = true;
        vm.originalPaymentDetails = cloneDeep(vm.booking.paymentDetails);
      } else {
        showPaymentChangedMessage()
      }
      // We have to check for pax validation for BO but not for Upsell options
      if ((!isEmpty(vm.activePaymentDetails.menuOptions) && isPaxThresholdValid) || !isEmpty(vm.activePaymentDetails.menuOptionsUpsell)) {
        if (vm.allBookingOptions.length === 0) {
          vm.allBookingOptions = await BookingOptionsManagerService.getAll();
        }
        vm.menuOptions = (vm.activePaymentDetails.menuOptions || []).map(id =>
          Object.assign(vm.allBookingOptions.find(option => option._id === id), {id: id}) // adding a object id in MenuOption to has the same type like ISimpleBookingOption
        );

        vm.menuOptionsUpsell = (vm.activePaymentDetails.menuOptionsUpsell || []).map(id =>
          Object.assign(vm.allBookingOptions.find(option => option._id === id), {id: id}) // adding a object id in MenuOption to has the same type like ISimpleBookingOption
        );

        const {
          isUpsellOptions,
          upsellOptionsValid,
        } = BookingValidationService.setUpsellOptionsValidity(vm.activePaymentDetails);
        vm.isUpsellOptions = isUpsellOptions;
        vm.upsellOptionsValid = upsellOptionsValid;

        const {
          isBookingOption,
          bookingOptionsValid
        } = BookingValidationService.setBookingOptionsValidity(vm.activePaymentDetails, vm.booking.people);
        vm.isBookingOption = isBookingOption;
        vm.bookingOptionsValid = bookingOptionsValid;

        const newOptions = {options: vm.menuOptions, optionsUpsell: vm.menuOptionsUpsell};
        vm.activePaymentDetails = {...vm.activePaymentDetails, ...newOptions};
        vm.serviceId = vm.booking.serviceId;
        MenuOptionReducerService.setBooking({...vm.booking, selectedMenuOptions: []});
        MenuOptionReducerService.setActiveService({...vm.service});
        MenuOptionReducerService.setEditCachedMenuOptionDetails(updateMenuOptionCachedDetails(vm.allBookingOptions));
        updateTabs();
      }
    } else if (bookingToMove) {
      // bookingToMove gets populated if change date is clicked in edit booking.
      // If bookingToMove is present then we need to take that payment details if booking from diary or payment pending if the booking is made from widget.
      vm.booking.paymentDetails = (bookingToMove.paymentDetails || bookingToMove.paymentPending) ? cloneDeep(bookingToMove.paymentDetails || bookingToMove.paymentPending) : {paymentType: PaymentTypes.NoPayment};
    } else {
      vm.booking.paymentDetails = {
        paymentType: PaymentTypes.NoPayment,
      };
    }
  }

  const getStaffNewSetting = () => {
    if (vm.isBookingToMove) {
      return setting?.staffNew?.changingDate
    }
    if (vm?.booking?.bookingType === BookingType.WaitList) {
      return setting?.staffNew?.creatingWalkin
    }
    if (bookingMethod === BookingMethods.walkin) {
      return setting?.staffNew?.creatingWalkin
    }
    return setting?.staffNew?.creatingBooking === undefined ? true : setting?.staffNew?.creatingBooking
  }

  function initBooking(bookingToMove, bookDate, bookTable) {
    var isToday = DateUtilsService.isDateToday(bookDate, vm.venue.timeZoneId);
    vm.isBookingToMove = (bookingToMove != null);
    vm.staffEnabled = setting.staffEnabled ? true : false;

    vm.staffRequired = (setting.staffRequired && vm.staffEnabled)
      ? getStaffNewSetting()
      : false;
    // booking;
    vm.statusName = (isToday && setting.autoConfirm) ? BookingStatusNames.Confirmed : StatusServiceInstance.getUnconfirmedStatusName();

    const {statusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
    const selectedStatus = statusOptions.find((status) => status.name === vm.statusName);

    if (bookingToMove) {
      vm.statusName = bookingToMove.status.name;
      vm.booking = ObjectCopyService.angularSafeCopy(bookingToMove);
      vm.heading = 'Move Booking';
      vm.isNewBooking = false;
      vm.tableSeaterManualJoinType = ManualJoinType.forceManualJoin;
      if (!bookingToMove.customerId) {
        console.warn('No customer id found - Taking Data from booking object');
        vm.customer = CustomerGeneratorService.getCustomerInfo(bookingToMove);
      }
    } else {
      vm.booking = {
        bookingType: bookingMethod === BookingMethods.walkin ? BookingType.WaitList : BookingType.Booking,
        type: 'booking',
        people: 2,
        customersCovid: [],
        duration: 90,
        preferredSectionId: bookTable ? bookTable.sectionId : 'any',
        status: selectedStatus,
        method: bookingMethod,
        locked: false,
        paymentDetails: {
          paymentType: PaymentTypes.NoPayment
        },
        tags: [],
        additionalPaymentDetails: []
      };
    }

    MenuOptionReducerService.setBooking(ObjectCopyService.angularSafeCopy(vm.booking));

    // form values
    if (bookDate) {
      vm.bookingDate = bookDate;
      if (vm.bookingDate.getHours() !== 0 || vm.bookingDate.getMinutes() !== 0) {
        vm.bookingTime = bookDate;
      }

    } else {
      vm.bookingDate = DateUtilsService.getVenueTime(vm.venue.timeZoneId);
    }
    if (bookTable) {
      vm.tableId = bookTable._id;
      vm.tableSection = bookTable.sectionId;
    }
    vm.initialTableId = vm.tableId;
  }

  function checkStatus() {
    var isToday = DateUtilsService.isDateToday(vm.bookingDate, vm.venue.timeZoneId);
    if (setting && !bookingToMove) {
      const {statusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
      var statusToSelect = (isToday && setting.autoConfirm) ? BookingStatusTypes.Confirmed : StatusServiceInstance.getUnconfirmedStatusName();
      for (var i = 0; i < statusOptions.length - 1; i++) {
        var selectedStatus = statusOptions[i];
        if (selectedStatus.statusType === statusToSelect) {
          vm.statusName = selectedStatus.name;
          vm.booking.status = selectedStatus;
          break;
        }
      }
    }
  }

  function checkPermanentTags() {
    // add any permanent tags
    if (vm.customer && vm.customer.tags) {
      const tags = TagsService.checkPermanentTags(vm.customer.tags, vm.booking.tags);
      if(tags) vm.booking.tags = tags;
      updateLables();
    }
  }

  function setPhone() {
    vm.bookingMethod = BookingMethods.phone;
    vm.booking.method = BookingMethods.phone;
  }

  function setEmail() {
    vm.bookingMethod = BookingMethods.email;
    vm.booking.method = BookingMethods.email;
  }

  function toggleLocked() {
    vm.booking.locked = !vm.booking.locked;
  }

  function getSectionsLookUp() {
    SectionLookupService.getSectionsLookUp().then(function (sections) {
      vm.sectionsLookup = sections;
    }).catch(function (err) {
      $log.error('error getSectionsLookUp', err);
    });
  }

  function getPaymentTypeName(paymentType) {
    return $filter('paymentTypeLabelFilter')(paymentType);
  }

  function tryAgain() {
    vm.state = vm.ENTER;
  }

  function backTab() {
    vm.selectedTab--;
  }


  /**
   *
   * Navigates to next step if there are no errors
   * @param bookingType - optional
   */
 function nextTab(bookingType) {

    if (bookingType && bookingType === BookingType.WaitList) {
      vm.staffEnabled = setting.staffEnabled ? true : false;

      vm.staffRequired = (setting.staffRequired && vm.staffEnabled)
        ? getStaffNewSetting()
        : false;
    }
    validationChecked();

    if (!vm.detailsValid) {
      BookingValidationService.scrollToValidationError(vm.selectedTab, vm.validationList);
    }

    if (vm.selectedTab === 0 && !vm.detailsValid) {
      vm.displayErrors = 1;
      return;
    }
    const isCustomerTab = vm.showTabs.repeatBookingTab ? vm.selectedTab === 2 : vm.selectedTab === 1;
    if (isCustomerTab && !vm.customerValid) {
      vm.displayErrors = 2;
      return;
    }
    vm.selectedTab++;
  }

  function tagChange(newValue, oldValue) {
    updateTabs(true);
    var tabsNames = vm.tabs;
    TrackingService.trackPageView(pagePath + '.' + tabsNames[vm.selectedTab], {
      bookingMethod: bookingMethod
    });
    if (!vm.initialTag) {
      setTimeout(() => { // We are putting a setTimeout to deal with the issue to trigger an event once the booking form is loaded with the updated values in vm.booking.
        vm.initialTag = true;
        vm.oldBooking = ObjectCopyService.angularSafeCopy(vm.booking);
        console.log('vm.oldBooking**', angular.toJson(vm.oldBooking));
      }, 1000);
    }

  }

  /**
   * Display "CREATE REPEAT BOOKING" button on the customer tab, when the below fields are provided:
   * 1. Service
   * 2. Table
   * 3. Customer
   */
  function allowRepeatBooking() {
    if (vm.booking.time) {
      const isTimeExpired = RecurringBookingService.checkForExpiredTime(DateUtilsService.onlyChangeTimeZone(vm.booking.time, vm.venue.timeZoneId), moment());
      const isTimeBeforeLastTime = vm.service && vm.service.lastBookingTime ? RecurringBookingService.checkForExpiredTime(vm.booking.time, moment(vm.service.lastBookingTime)): null;
      vm.shouldShowRepeatBookingIcon = setting.enableRecurringBookings && isTimeBeforeLastTime && !isTimeExpired && vm.booking.serviceId && vm.booking.tables?.length > 0;
    } else {
      return false;
    }
  }

  /**
   * Remove the repeat booking tab, after the recurring bookings are created successfully
   */
  function closeRepeatBookingTab() {
    vm.openRepeatBookingTab = false;
  }

  function useStandBy() {
    return vm.isStandbyListEnabled && vm.bookingMethod !== vm.walkin;
  }

  function isStaffCheckValid() {
    return vm.staffRequired && !vm.staffName;
  }

  /**
   * This method will be called whenever, the user selects the customer profile from the auto-complete dropdown.
   */
  function onCustomerIdChange() {
    getCustomerBookings();
    getCustomerAverageSpendInfo();
    // Hiding wine button again as part of https://nowbookit.atlassian.net/browse/NBI-4608
    // getBeverageList();
    vm.beverageList = [];
  }

  /**
   * Provides the list of customer bookings for a specific venue
   */
  async function getCustomerBookings() {

    if (vm.customer._id) {

      // getBookingsByCustomerIds() accepts a list of customer ids, so passing the customerid as an array
      const customerBookingList = await BookingLookupService.getBookingsByCustomerIds([vm.customer._id], true);

      // Filter the bookings
      vm.customerBookings = customerBookingList.filter(booking => BookingValidationService.isValidPastBooking(booking));
    }
  }

  /**
   * Provides the list of customer bookings for a specific venue
   */
  async function getCustomerSBL(customerId) {

    if (customerId) {
      const results = await BookingLookupService.getBySchedule(vm.schedule);
      if (results?.schedule._id === vm.schedule._id) {
        const bookings = results.bookings;
        // Filter the bookings
        const _bookings = bookings.filter(booking => booking.customerId === customerId);
        const bookingsList = BookingListFilterService.getCategorisedBookingList(_bookings, true); // @todo Need to check 2nd param, vm.isStandbyListEnabled = AdminService.getVenue().standByList;
        return (bookingsList && bookingsList.standByListCount) ? bookingsList.standByListCount : [];
      }
    }

    return [];
  }

   /**
   * Cancel Previous SBL   */
   async function setCustomerSBLToCancelled() {

    if (vm.customerSBL.length > 0) {
      const requests = [];
      vm.customerSBL.forEach((booking) => {
        requests.push(BookingUpdateService.setToCancelled(booking))
      });

      return new Promise((resolve) => {
        Promise.all(requests).then((results) => {
          resolve(results);
        })
      });
    } else return Promise.resolve(true);
  }

  async function getCustomerAverageSpendInfo() {
    vm.avgSpendAmount = await ReportingService.getCustomerAmountDetails(vm.venue.id, vm.customer._id);
  }

  async function getBeverageList() {

    if (vm.customer?._id) {
      vm.beverageList = await BeverageHistoryService.getCustomerBeverageInfo(vm.venue.id, vm.customer._id);
    }
  }

  function validationChecked() {
    vm.nextDisabled = false;
    vm.detailsValid = false;
    vm.validationList = []; // order of items determines which will be scrolled to first

    vm.detailsValid = BookingValidationService.getBookingDetailsValidation(
      vm.booking, vm.selectedTime, useStandBy(), isStaffCheckValid(), vm.validationList
    );

    vm.paymentValid = BookingValidationService.isBookingPaymentValid(vm.booking.paymentDetails)

    vm.canSave = BookingValidationService.canSaveNewBookings({
      detailsValid: vm.detailsValid,
      customerValid: vm.customerValid,
      paymentValid: vm.paymentValid,
      guestListValid: vm.guestListValid,
      bookingDateTime: vm.booking.time,
      bookingToMoveDateTime: bookingToMove?.time
    });

    if (vm.selectedTab === 0) {
      // make sure we have a time
      vm.nextDisabled = !vm.detailsValid;
    }
    if (vm.showTabs.repeatBookingTab && vm.selectedTab === 1) {
      vm.nextDisabled = false;
    }
    if (vm.showTabs.repeatBookingTab ? vm.selectedTab === 2 : vm.selectedTab === 1) {
      // make sure we have a customer
      vm.nextDisabled = !vm.customerValid;
    }
  }

  function addRepeatBookingTabBeforeCustomer(tabList, index) {
    const tabsBeforeRecurring = tabList.slice(0, index);
    const tabsAfterRecurring = tabList.slice(index, tabList.length - 1);
    return [...tabsBeforeRecurring, ...[REPEAT_BOOKING_TAB], ...tabsAfterRecurring];
  }

  function RemoveRepeatBookingTab(tabList) {
    return tabList.filter((item) => item !== REPEAT_BOOKING_TAB)
  }

  function updateTabs(value, oldValue) {
    vm.showTabs.booking = true;
    vm.showTabs.customer = vm.isNewBooking;
    vm.showTabs.tags = vm.isNewBooking;
    vm.showTabs.notes = vm.isNewBooking;
    vm.showTabs.guestList = vm.isNewBooking ? vm.venue.isCovidGuestMode : false;
    vm.showTabs.bookingOptions = !updateOfflineStatus() && vm.isBookingOption;
    vm.showTabs.upsellOptions = !updateOfflineStatus() && vm.isUpsellOptions;
    vm.showTabs.bookingLinksTab = vm.isNewBooking;

    if (vm.selectedTab === 0 || vm.selectedTab === 1) {
      allowRepeatBooking();
    }

    const doesRepeatBookingTabExist = vm.tabs.find((item) => item === REPEAT_BOOKING_TAB);
    // Add the repeat booking tab, when "CREATE REPEAT BOOKING" button is clicked on the customer tab
    if (vm.openRepeatBookingTab) {
      if (!doesRepeatBookingTabExist) {
        vm.tabs = addRepeatBookingTabBeforeCustomer(vm.tabs, 1);
        vm.showTabs.repeatBookingTab = true;
        vm.selectedTab = 1;
      }
    }
    if (!vm.openRepeatBookingTab && doesRepeatBookingTabExist) {
      vm.tabs = RemoveRepeatBookingTab(vm.tabs);
      vm.showTabs.repeatBookingTab = false;
      // Reset Recurring bookings on toggle off
      vm.requestParameters = {};
      vm.bookingList = [];
      vm.booking.recurringBookingId = '';
      vm.selectedTab = 0;
    }

    if (vm.venue.isCovidGuestMode) {
      if (!vm.tabs.find((item) => item === GUESTLIST_TAB)) {
        vm.tabs.push(GUESTLIST_TAB);
      }
    }

    if (vm.isBookingOption && !vm.tabs.find((item) => item === BOOKING_OPTIONS_TAB)) {
      // removing payment tab cause its already added - need to add it to the last
      if (vm.tabs.find((item) => item === PAYMENT_TAB)) {
        vm.tabs = vm.tabs.filter(t => t !== PAYMENT_TAB)
      }
      vm.tabs.push(BOOKING_OPTIONS_TAB);
    }

    if (vm.isUpsellOptions && !vm.tabs.find((item) => item === UPSELL_OPTIONS_TAB)) {
      // removing payment tab cause its already added - need to add it to the last
      if (vm.tabs.find((item) => item === PAYMENT_TAB)) {
        vm.tabs = vm.tabs.filter(t => t !== PAYMENT_TAB)
      }
      vm.tabs.push(UPSELL_OPTIONS_TAB);
    }

    if (vm.venue && vm.venue.isPaymentsConfigured && vm.isNewBooking && vm.bookingMethod !== vm.walkin) {
      if (!vm.tabs.find((item) => item === PAYMENT_TAB)) {
        vm.tabs.push(PAYMENT_TAB);
      }
      vm.showTabs.payment = true;
    }

    if (!isNaN(vm.selectedTab) && (value || oldValue)) {
      vm.backLabel = (vm.selectedTab > 0) ? vm.tabs[vm.selectedTab - 1] : false;
      vm.nextLabel = (vm.selectedTab < vm.tabs.length - 1) ? vm.tabs[vm.selectedTab + 1] : false;
      vm.showSave = vm.selectedTab === vm.tabs.length - 1;
      validationChecked();
    }
    updateLables();
  }

  function updateLables() {
    //-- booking
    var bookingItems = [];
    if (vm.booking.time) {
      if (vm.booking.tableNo) {
        bookingItems.push('T' + vm.booking.tableNo);
      }
      if (vm.booking.people) {
        bookingItems.push(vm.booking.people + 'p');
      }
      bookingItems.push($filter('date')(vm.booking.time, 'h:mma d/M/yy '));
    }
    vm.bookingLabel = '';
    if (bookingItems.length) {
      vm.bookingLabel = bookingItems.join(' ');
    }

    //-- customer
    var customerItems = [];
    if (vm.customer.firstName) {
      customerItems.push(vm.customer.firstName);
    }
    if (vm.customer.lastName) {
      customerItems.push(vm.customer.lastName);
    }
    if (vm.customer.phone) {
      customerItems.push(vm.customer.phone);
    }
    vm.customerLabel = '';
    if (customerItems.length) {
      vm.customerLabel = customerItems.join(' ');
    }

    //-- tags
    var tagsItems = [];
    if (vm.booking.tags) {
      for (var i = vm.booking.tags.length - 1; i >= 0; i--) {
        var tag = vm.booking.tags[i];
        if (tag && tag.tagtype) {
          var index = tagsItems.indexOf(tag.tagtype.name);
          // make sure the tag is not already in the array
          if (index === -1 && tag) {
            tagsItems.push(tag.tagtype.name);
          }
        }

      }
    }
    vm.tagsLabel = '';
    if (tagsItems.length) {
      tagsItems.sort(TagsService.compareTagIcons);
      vm.tagsLabel = tagsItems.join(', ');
    }

    //-- notes && customer
    var notesItems = [];
    if (vm.booking.notes) {
      notesItems.push('Booking');
    }
    if (vm.customer.notes) {
      notesItems.push('Customer');
    }
    if (vm.customer.managerNotes && vm.isManager) {
      notesItems.push('Manager');
    }
    vm.notesLabel = '';
    if (notesItems.length) {
      vm.notesLabel = notesItems.join(', ');
    }
  }

  function statusUpdate() {
    // set the status
    const {statusOptions} = StatusConfigService.getMutableStatusOptionsFromStore(store.getState());
    for (var i = 0; i < statusOptions.length - 1; i++) {
      var status = statusOptions[i];
      if (status.name === vm.statusName) {
        vm.booking.status = status;
        break;
      }
    }
  }

  function closeDialog() {
    NetworkConnectionService.checkCouchDbIsReachable();
    $mdDialog.hide();
  }


  function cancelDialog() {
    NetworkConnectionService.checkCouchDbIsReachable();
    $mdDialog.cancel();
  }

  function handleOriginalCustomerChange(_customerCopy) {
    customerCopy = _customerCopy;
  }

  function showEditCustomerConfirmation() {
    var tempCustomer = cloneDeep(vm.customer);
    tempCustomer = PhoneNumberService.resetPhoneNumberWithTypeValidation(tempCustomer); // Remove country prefix when national number contains special char and a~z A~Z

    // const diffInfoList = CustomerService.checkDifference(customerCopy, vm.customer);
    const diffInfoList = CustomerService.checkDifference(customerCopy, tempCustomer);
    const dialogMessage = `You are about to update an existing customer record, would you like to proceed? <div>Current Details: ${customerCopy.fullName || ''} ${customerCopy.phone && customerCopy.phone.trim() != '' ? `(${customerCopy.phone})` : ''} ${customerCopy.email || ''}</div>`;
    const headerMsg = 'Save confirmation';
    SimpleDialogActions.showDialog({
      description: dialogMessage,
      title: headerMsg,
      confirmText: 'Continue',
      rejectText: 'Cancel',
      handleConfirm: () => {
        SimpleDialogActions.hideDialog();
        vm.customer.edited = false;
        save();
      },
      handleReject: () => {
        SimpleDialogActions.hideDialog();
      },
      diffInfoList,
      dialogSize: 'md'
    });
  }

  function checkForSave() {
    if (vm.customer._id && vm.customer._rev && vm.customer.edited) {
      showEditCustomerConfirmation();
    } else {
      if (!vm.isLoadingBookingOptionsPaymentInfo) {
        LinearSaveService.linearSave(save);
      }
    }
  }

  function checkForRecurringBookingSelection() {
    if (vm.showTabs.repeatBookingTab && !vm.isRecurringBookingSaved) {
      vm.selectedTab = 1;
      return false;
    } else {
      return true;
    }
  }

  function checkForPaymentChanged() {
    if (vm.paymentDetailsChanged) {
      vm.paymentDetailsChanged = false;
      return true;
    } else {
      return false;
    }
  }

  async function updateRecurringBookings(recurringBookingInfo) {
    vm.bookingList = recurringBookingInfo.bookingList.map(item => item.booking);
    if (!isEmpty(vm.bookingList)) {
      vm.requestParameters = RecurringBookingService.MakeRecurringBookingRequestForSaveBooking(recurringBookingInfo, vm.booking);
      vm.requestParameters.bookings = vm.bookingList;
      vm.requestParameters.recurringBooking.id = createRecurringBookingID();
      vm.booking.recurringBookingId = createRecurringBookingID();
    } else {
      vm.booking.recurringBookingId = null;
    }
    vm.selectedTab = 2;
    vm.isRecurringBookingSaved = true;
  }

  function resetRecurringBookings() {
    vm.bookingList = [];
    resetTableData()
  }

  function resetTableData() {
    vm.tableList = [...vm.tableList];
  }

  function createRecurringBookingID() {
    return `recurringbooking_${Date.now()}`;
  }

  async function save(blockedCB) {
    // for check duplication customer before save.
    // if customer is duplicated, stop save function, the booking will jump to customer search page.
    if(vm.customerValid && vm.bookingMethod !== BookingMethods.walkin && vm.booking.bookingType !== BookingType.StandbyList) {
      try {
        const isDuplicate = await checkDuplicatedCustomer();
        if (isDuplicate) {
          blockedCB();
          return;
        }
      } catch (e) {
        console.log(e);
      }
    }
    var tempCustomer = cloneDeep(vm.customer);
    tempCustomer = PhoneNumberService.resetPhoneNumberWithTypeValidation(tempCustomer); // Remove country prefix when national number contains special char and a~z A~Z

    NetworkConnectionService.checkCouchDbIsReachable();

    if (vm.canSave) {

      // if no email or phone provided - do not save customer info - dont call customer api
      if (bookingMethod === BookingMethods.phone && (!tempCustomer.email && !tempCustomer.phone)) {
        tempCustomer.customerType = CustomerTypes.inline;
      }

      if (vm.booking.tables?.length > 1) { // If table join exists, by default enableTableJoinDrag
        vm.booking.enableGroupDrag = true;
      }

      if (!vm.bookingOptionsValid && !updateOfflineStatus()) {
        vm.selectedTab = (vm.showTabs.upsellOptions ? vm.tabs.length - 3 : vm.tabs.length - 2) + vm.paymentAvailableTabOffset;
        blockedCB();
        return;
      }

      const isUpsellOptionsValid = BookingValidationService.checkForUpsellValidation({
        isUpsellOptions: vm.isUpsellOptions,
        activePaymentDetails: vm.activePaymentDetails,
        upsellOptionsValid: vm.upsellOptionsValid,
        upsellPageSkip: vm.upsellPageSkip,
        showUpsellOptions: vm.showUpsellOptions,
      });


      if (!isUpsellOptionsValid && !updateOfflineStatus()) {
        vm.selectedTab = vm.tabs.length - 2  + vm.paymentAvailableTabOffset;
        blockedCB();
        return;
      }

      if (!checkForRecurringBookingSelection()) {
        blockedCB();
        return;
      }

      const state = MenuOptionReducerService.getState();
      // if BO or Upsell is present then we saving the selectedMenuOptions in state and taking value from there before saving.
      if (state && state.booking && !isEmpty(state.booking.selectedMenuOptions)) {
        vm.booking.selectedMenuOptions = MenuOptionsServiceShared.getFlatExtras(state.booking.selectedMenuOptions);
      }

      vm.booking.bookingLinks = vm.bookingLinks; // adding links information to the booking object before saving.

      const isNoPayment = vm.booking.paymentDetails && vm.booking.paymentDetails.paymentType === PaymentTypes.NoPayment;
      const proceedToSave = vm.booking.paymentDetails && !checkForPaymentChanged() && (
        vm.selectedTab === vm.tabs.length - 1 || vm.finalConfirmation);

      // show payment tab if the user hasn't checked it before saving, otherwise proceed to save
      if (!vm.showTabs.payment || isNoPayment || proceedToSave) {

        /**
         * Check sbl restrict for diary
         */

        if (!BookingValidationService.isMovedBookingSameTime(vm.booking.time, bookingToMove?.time) && vm.venue.isRestrictDiaryBookingOnSBL) {
          const isRestrict = await detectSBLByCustomer(tempCustomer);
          if (isRestrict) {
            blockedCB();
            return;
          }
        }


        var t0 = performance.now();
        vm.state = vm.LOADING;

        if (vm.bookingMethod === BookingMethods.walkin) {
          StatusServiceInstance.forceSeatedWalkinToSeatedStatus(vm.booking);
        }

        if (vm.booking.selectedMenuOptions.length > 0) {
          vm.booking.selectedOptions = MenuOptionsService.updateSelectedOptions(cloneDeep(vm.booking.selectedMenuOptions), vm.allBookingOptions);
          vm.booking.tags = TagsService.mergeAndGetUniqueTags(vm.booking.selectedOptions, vm.allTags, vm.booking.tags); // Getting the tags from BO and children
        }

        if (!vm.booking.preferredSectionId) {
          const notes = `Booking Data: {"_id": "${vm.booking._id}",
                      "_rev": "${vm.booking._rev}", "bookingType": "${vm.booking.bookingType}", "tables": "${vm.booking.tables}"}`;
          AdminService.serverLoggingDbEvents(AdminService.getVenue().id.toString(), 'SECTION_ID_ERROR - NEW_BOOKING - Booking is being saved without a preferred section id', AdminServiceLog.WARNLOG, notes);
          console.warn('SECTION_ID_ERROR - NEW_BOOKING - Booking is being saved without a preferred section id', vm.booking);
        }
        //check whether need force update customer
        const forceUpdateCustomer = CustomerUpdateService.shouldForceUpdateCustomer(vm.venue.id, vm.customer, vm.originalCustomer);
        // Check if the booking is being moved then if the date changed, if so add new booking, cancel old booking. Otherwise just update the booking
        if (BookingValidationService.isMovedBookingSameTime(vm.booking.time, bookingToMove?.time)) {
          // Update booking


          BookingUpdateService.updateFromAnywhere(vm.booking, bookingToMove, tempCustomer, true, vm.staffName, null, null, false, forceUpdateCustomer).then(booking => {
            TelemetryService.track('saveBooking', [
              ['duration', performance.now() - t0]
            ]);

            vm.state = vm.SUCCESS;
            LinearSaveService.removeLinearSave();
            vm.heading = 'BOOKED';
            vm.savedBooking = booking;

            vm.customerNewEmail = vm.savedBooking.email;

          }).catch(function (err) {
            vm.state = vm.ERROR;
            LinearSaveService.removeLinearSave();
            $log.warn('newBookingController.save update old booking', err);
          });
        } else {
          // Since we're going to be creating a new booking with out old booking data, we need to remove _rev and _id to avoid PouchDB conflict

          BookingsUtilsService.clearBookingIdentifiers(vm.booking);

          // add staff name to booking
          vm.booking.staffName = vm.staffName;

          // they just added a payment set the status to payment pending (if it is enabled)
          if (!bookingToMove && StatusService.hasPayment(vm.booking.paymentDetails)) {
            const pendingPaymentStatus = StatusServiceInstance.getPaymentPendingStatus();
            if (pendingPaymentStatus) {
              vm.booking.status = pendingPaymentStatus;
            }
          }

          if (vm.booking.isBookedBy && !bookingToMove) {
            TagsService.addBookedByTag(vm.booking.tags);
            vm.booking = {
              ...vm.booking,
              bookedBy: vm.bookedByCustomerDetails
            }
          }

          console.log(NS, 'save -> vm.booking', vm.booking)
          console.log(NS, 'vm.customer', tempCustomer, vm.customer)
          const isRecurringBooking = !isEmpty(vm.bookingList) && !isEmpty(vm.requestParameters);
          // Add the booking
          BookingUpdateService.add(vm.booking, tempCustomer, bookingToMove, vm.schedule, isRecurringBooking,forceUpdateCustomer).then(async (booking) => {

            // we get the customer id for newly created customer as well and pass to recurring booking
            if (isRecurringBooking) {
              vm.requestParameters.bookings = RecurringBookingService.updateRecurringBookingsProps(vm.requestParameters.bookings, vm.booking);
              RecurringBookingService.updateRecurringBookingsCustomer(vm.requestParameters.recurringBooking, tempCustomer, booking.customerId);
              console.log('vm.requestParameters', vm.requestParameters);
              await RecurringBookingService.SaveRecurringBooking(vm.requestParameters);
              BookingNotificationsService.sendNotification(booking, BookingNotificationsService.NEW);
            }
            vm.heading = booking.bookingType === BookingType.StandbyList ? 'Added to Standby List' : 'BOOKED';
            vm.savedBooking = booking;

            TelemetryService.track('saveBooking', [
              ['duration', performance.now() - t0]
            ]);

            if (bookingToMove) {
              // NBI-9366 - need to update the booking end time for moved booking so that it appears correctly when change date is clicked.
              booking.bookingEnd = DateUtilsService.getBookingEnd({time: booking.time, duration: booking.duration});
              AppEventService.emit('bookingMoved', booking); // To send the new booking object to the main.controller.
            }


            $rootScope.$broadcast('booking-new', booking);

            if ((booking.bookingType === BookingType.Booking && vm.savedBooking.paymentDetails && vm.savedBooking.paymentDetails.paymentType !== PaymentTypes.NoPayment)) {
              generateBookingUrl();
              vm.state = vm.SHOW_PAYMENT_URL;
            } else {
              vm.state = vm.SUCCESS;
            }

            vm.customerNewEmail = vm.savedBooking.email;
            LinearSaveService.removeLinearSave();

            if (bookingToMove) {
              return BookingUpdateService.setToCancelled(bookingToMove, booking.staffName, BookingStateChangeTypes.DATE_CHANGED);
            }

          }).catch(function (err) {
            vm.state = vm.ERROR;
            LinearSaveService.removeLinearSave();
            $log.warn('newBookingController.save add new booking and cancel old booking ', err);
          });
        }

      } else {
        vm.selectedTab = vm.tabs.length - 1;
        vm.finalConfirmation = true;
        LinearSaveService.removeLinearSave();
      }
    } else {
      const {
        selectedTab, displayErrors, forceGuestListValidation
      } = BookingValidationService.getTabValidationRules(vm.booking, vm.selectedTime, vm.tabs.length, {
        customerValid: vm.customerValid,
        detailsValid: vm.detailsValid,
        paymentValid: vm.paymentValid,
        isCovidGuestMode: vm.venue.isCovidGuestMode,
        guestListValid: vm.guestListValid,
        bookingOptionsValid: vm.bookingOptionsValid,
        isBookingOption: vm.isBookingOption,
        isRecurringBooking: vm.showTabs.repeatBookingTab
      }, useStandBy(), isStaffCheckValid());
      vm.selectedTab = selectedTab;
      if ((vm.showTabs.repeatBookingTab ? vm.selectedTab === 2 : vm.selectedTab === 1)) {
        vm.switchCustomerView = !vm.switchCustomerView;
      }
      vm.displayErrors = displayErrors;
      vm.forceGuestListValidation = forceGuestListValidation;

      BookingValidationService.scrollToValidationError(vm.selectedTab, vm.validationList);
      LinearSaveService.removeLinearSave();
    }
  }
//----------------move this function updateBookings to recurring-booking-service----------------

  async function detectSBLByCustomer(tempCustomer) {
    const customerSBLCheck = await CustomerSearchService.detectSBLByCustomer(tempCustomer, vm.booking.bookingType, vm.isCancelPreviousSB, vm.schedule);
    tempCustomer.firstName = customerSBLCheck.customer.firstName;
    tempCustomer.lastName = customerSBLCheck.customer.lastName;
    vm.customerSBL = customerSBLCheck.customerSBL;

    if(customerSBLCheck.result === RestrictResult.NotRestrict) return false;
    if(customerSBLCheck.result === RestrictResult.CancelPreviousSBLConfirmation) {
      showCancelPreviousSBLConfirmationDialog();
    } else if (customerSBLCheck.result === RestrictResult.TryConfirm) {
      showTryConfirmationDialog();
    }
    return true;
  }

  function generateBookingUrl() {
    vm.paymentUrl = '';
    if (PaymentService.bookingHasUnpaidPayment(vm.savedBooking)) {
      vm.paymentUrl = UrlGeneratorService.generateBookingUrl(vm.savedBooking._id);
    }
  }

  function handleBookingUpdated(booking) {
    vm.booking = booking;
    bookingReactRerender();
    vm.bookingMethod = booking.method;
  }

  // triggers a react rerender
  function bookingReactRerender() {
    vm.booking = {...vm.booking};
  }

  function updateBookingOption(booking, isUpsell = false) {
    if (vm.bookingOptionsValid || isUpsell) {
      vm.upsellOptionsValid = isUpsell;
      if (isUpsell) {
        vm.upsellPageSkip = true; // to not show the upsell page once it has been displayed and some action already done on that page
      }

      // combines with existing and runs equality check on objects to prevent duplicates
      const newMenuOptions = MenuOptionsService.combineBookingOptions(booking.selectedMenuOptions, vm.booking.selectedMenuOptions, isUpsell);
      updatePaymentBasedOnBookingOptions(newMenuOptions, isUpsell);

      vm.booking.selectedMenuOptions = newMenuOptions;
      const state = MenuOptionReducerService.getState();
      updateBookingState(state, vm.booking.selectedMenuOptions);
    }
    /**
     * Note: if vm.bookingOptionsValid is false (and isUpsell is false as well), we don't update payment details.
     * Only update payment details when booking options are valid or toggled off.
     */

    vm.selectedMenuOptions = booking.selectedMenuOptions;
  }

  function handleMaxCovers(isSuccess) {
    vm.bookingOptionsValid = isSuccess;
  }

  function updatePaymentBasedOnBookingOptions(selectedMenuOptions, isUpsell = false) {
    selectedMenuOptions = selectedMenuOptions.filter(item => item.quantity > 0);

    vm.isLoadingBookingOptionsPaymentInfo = true;

    if (paymentTypeSubs) { // stops spamming
      paymentTypeSubs.unsubscribe();
    }
    paymentTypeSubs = PaymentService.getBookingPaymentDetailsFromServiceAndBookingOptions(
      selectedMenuOptions, vm.serviceId, vm.selectedTime, vm.bookingTimes, vm.booking.people, isUpsell
    )
      .pipe(first())
      .subscribe(paymentDetails => {
        vm.isLoadingBookingOptionsPaymentInfo = false;
        if (paymentDetails) {
          vm.booking.paymentDetails = paymentDetails;
          showPaymentChangedMessage();
          vm.originalPaymentDetails = paymentDetails;
        } else {
          // @todo: handle error
        }
      });
  }

  function toggleBookingOptions() {
    if (!vm.showBookingOption) {
      vm.bookingOptionsValid = true;
      vm.booking.selectedMenuOptions = vm.showUpsellOptions ? vm.booking.selectedMenuOptions.filter(s => s.isUpsellItem === true) : []; // will give only upsell options if they are selected
      const state = MenuOptionReducerService.getState();
      updateBookingState(state, vm.booking.selectedMenuOptions);
      if (!isEmpty(vm.booking.selectedMenuOptions)) {
        updatePaymentBasedOnBookingOptions(vm.booking.selectedMenuOptions, true);
      } else {
        vm.booking.paymentDetails = {
          paymentType: PaymentTypes.NoPayment,
        };
        showPaymentChangedMessage();
      }
    } else {
      const state = MenuOptionReducerService.getState();
      vm.booking.selectedMenuOptions = state.booking ? state.booking.selectedMenuOptions : [];
      const {
        isBookingOption,
        bookingOptionsValid
      } = BookingValidationService.setBookingOptionsValidity(vm.activePaymentDetails, vm.booking.people);
      vm.isBookingOption = isBookingOption;
      vm.bookingOptionsValid = bookingOptionsValid;
    }
  }

  function toggleUpsellOptions() {
    if (!vm.showUpsellOptions) {
      vm.upsellOptionsValid = true;
      vm.upsellPageSkip = true; // to not show the upsell page once it has been displayed and some action already done on that page
      vm.booking.selectedMenuOptions = vm.showBookingOption ? vm.booking.selectedMenuOptions.filter(s => s.isUpsellItem === false) : [];
      const state = MenuOptionReducerService.getState();
      updateBookingState(state, vm.booking.selectedMenuOptions);
      if (!isEmpty(vm.booking.selectedMenuOptions)) {
        updatePaymentBasedOnBookingOptions(vm.booking.selectedMenuOptions);
      } else {
        PaymentService.setPaymentDetailsOnBooking(vm.booking, vm.activePaymentDetails);
        showPaymentChangedMessage();
      }

    } else {
      const state = MenuOptionReducerService.getState();
      vm.booking.selectedMenuOptions = state.booking ? state.booking.selectedMenuOptions : [];
      const {
        isUpsellOptions,
        upsellOptionsValid,
      } = BookingValidationService.setUpsellOptionsValidity(vm.activePaymentDetails);
      vm.isUpsellOptions = isUpsellOptions;
      vm.upsellOptionsValid = upsellOptionsValid;
    }
  }

  function showPaymentChangedMessage() {
    vm.paymentDetailsChanged = vm.booking.paymentDetails.paymentType !== vm.originalPaymentDetails?.paymentType || vm.booking.paymentDetails.price !== vm.originalPaymentDetails?.price;
    if (vm.paymentDetailsChanged) {
      vm.isPaymentTypeChanged = vm.booking.paymentDetails.paymentType !== vm.originalPaymentDetails?.paymentType;
      vm.isPriceChanged = vm.booking.paymentDetails.price !== vm.originalPaymentDetails?.price;
    }
  }

  function updateBookingState(state, selectedMenuOptions) {
    const booking = {...vm.booking, selectedMenuOptions};
    state = {...state, booking};
    MenuOptionReducerService.setState(state);
  }

  function setEmptyCustomer() {
    vm.customer = CustomerGeneratorService.setEmptyCustomer(vm.customer, vm.bookingMethod, vm.booking && vm.booking.bookingType);
  }

  function updateOfflineStatus() {
    // if connection has already been lost, status isn't changed
    return AdminService.getVenue().isOnlineCustomersEnabled && !NetworkConnectionService.isOnline();
  }

  function updateMenuOptionCachedDetails(allBookingOptions) {
    return allBookingOptions.map(option => ({...option, id: option._id}));
  }

  function updateBookingLink(bookingLinks) {
    vm.bookingLinks = [...bookingLinks];
  }

  function addBookingLink() {
    const bookingLinks = BookingsUtilsService.addBookingLink(cloneDeep(vm.bookingLinks));
    updateBookingLink(bookingLinks) // to render react component
  }

  function handleSendLinkPaymentResponseAndCloseOnSuccess(errName) {

    if (errName) {
      console.warn('SendLinkPayment error', err);
      vm.state = errName === 'conflict' ? vm.ERROR_CONFLICT : vm.ERROR;
    }

    // generateBookingUrl();
    if (!errName) {
      // timeout just so we can see the success message briefly
      setTimeout(() => closeDialog(), 1500);
    }
  }

  function checkForCovidGuestTab() {
    if (vm.showTabs.repeatBookingTab) {
      return vm.selectedTab === 6;
    } else {
      return vm.selectedTab === 5;
    }
  }

  function paymentChange() {
    if (vm.isChangeByUser) {
      vm.originalPaymentDetails = cloneDeep(vm.booking.paymentDetails);
      vm.paymentDetailsChanged = false;
    }
  }

  function handleEmailSmsNotification() {
    if (!bookingToMove) {
      vm.booking.disableEmailSmsNotification = vm.disableEmailSmsNotification;
    }
  }

  /***
   * check if customer is duplicated
   * @returns {Promise<boolean>}
   */
  async function checkDuplicatedCustomer() {
    if (vm.skipCustomerDuplicationCheck) {
      return false;
    }
    if (!!bookingToMove) {
      return false;
    }
    // for inline customer, no need check
    if (!vm.customer.phone && !vm.customer.email) {
      return false;
    }
    let result = [];
    try {
      result = await CustomerSearchService.searchCustomer(vm.customer, vm.venue);
    } catch (err) {
      $log.error('error checkDuplicatedCustomer', err);
    }
    if (result && result.length > 0){
      // let search show result
      vm.customers = result;
      // jump to customer tab
      if(vm.showTabs.repeatBookingTab) {
        vm.selectedTab = 2;
      } else {
        vm.selectedTab = 1;
      }
      vm.isDuplicatedCustomer = true;
      // trigger switch view
      vm.switchCustomerView = !vm.switchCustomerView;
      return true;
    }
    return false;
  }

  /***
   * handle new customer selected
   * @param customer {object}
   * @param isJumpToNextTab {boolean} - jump to next tab
   */
  function handleNewCustomerSelected(customer, isJumpToNextTab = false) {
     if (customer && customer._id) {
       vm.customer = customer;
       vm.originalCustomer = cloneDeep(customer);
       vm.skipCustomerDuplicationCheck = true;
       vm.isDuplicatedCustomer = false;
       if (isJumpToNextTab) {
         vm.selectedTab++;
       }
     }
  }

  /***
   * set skipCustomerDuplicationCheck flag
   * @param flag {boolean}
   */
  function setSkipCustomerDuplicationCheck(flag) {
    vm.skipCustomerDuplicationCheck = flag;
  }
  function setHiddenDialog(flag) {
    vm.isHidden = flag;
  }

  function setBookedByCustomerDetails(key, value) {
    vm.bookedByCustomerDetails[key] = value;
  }

  function cleanBookedByData() {
    vm.bookedByCustomerDetails = {
      subscribed: vm.venue.defaultEmailSubscribedForDiary,
    };
  }
}

